export async function establishAuthenticatedSession({
  loadUser,
  markLoggedIn,
  markLoggedOut,
}) {
  try {
    const user = await loadUser();
    markLoggedIn();
    return user;
  } catch (error) {
    markLoggedOut();
    throw error;
  }
}
